import {
  InjectionToken,
  type Provider,
  type Signal,
} from '@angular/core';
import type { SscInputFieldLabelWidth } from '../directives/input-field-label.directive';

/**
 * Optional app- or route-level label column width for SSC field primitives
 * (`ssc-input`, `ssc-select`, `ssc-input-datetime`, etc.). Provide a `Signal` so values stay
 * reactive (e.g. breakpoint-driven).
 */
export const SSC_FIELD_LABEL_COLUMN_WIDTH = new InjectionToken<
  Signal<SscInputFieldLabelWidth | undefined>
>('SSC_FIELD_LABEL_COLUMN_WIDTH');

export function provideSscFieldLabelColumnWidth(
  factory: () => Signal<SscInputFieldLabelWidth | undefined>,
): Provider {
  return { provide: SSC_FIELD_LABEL_COLUMN_WIDTH, useFactory: factory };
}
